module.exports = __webpack_public_path__ + "img/CarPower.82bbf7e8.png";